import Router from 'app/Routes';

const App = () => {
  return (
    <Router />
  );
};

export default App;
